import { Component, EventEmitter, Inject, OnChanges, OnInit, Output, PLATFORM_ID, input, model, output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog'
import { Router } from '@angular/router';
import { ReportService } from 'src/app/services/report.service';
import { ReportForest } from 'src/app/models/reportForest.model';
import { ConfirmationToastComponent } from 'src/app/components/confirmation-toast/confirmation-toast.component';
import { ForestTreament } from 'src/app/models/forestTreatment.model';
import { TreamentSpecification } from 'src/app/models/forestSpecification.model';
import { isPlatformBrowser } from '@angular/common';
import Inputmask from "inputmask";

@Component({
  selector: 'app-emergency-stabilization',
  templateUrl: './emergency-stabilization.component.html',
  styleUrls: ['./emergency-stabilization.component.scss'],
  standalone: false
})


export class EmergencyStabilizationComponent implements OnChanges, OnInit {

  private readonly isBrowser: boolean;
  report = input.required<any>();
  pre_assessment_report: any;
  gis_specialist: any;
  nav = model.required<string>();
  status = output<number | undefined>();
  @Output() loaded = new EventEmitter();
  errorList: string[] = [];
  page = input("6");


  form = this.formBuilder.group({
    assessment_cost: [0],
  });
  displayedColumns = [
    'types',
    'treatment',
    'spec_number',
    'spec_name',
    'off_nfs',
    'outside_fire',
    'unit_type',
    'unit_qty',
    'unit_cost',
    'total'
  ]
  footerDisplayedColumns = [
    'types',
    'total'
  ]
  forestTreatments: any;
  totalRequested = 0;

  constructor(
    public dialog: MatDialog,
    private readonly router: Router,
    private readonly formBuilder: FormBuilder,
    public readonly reportService: ReportService,
    public readonly toast: ConfirmationToastComponent,
    @Inject(PLATFORM_ID) platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  async setMask() {
    let assessmentCost
    if (this.isBrowser) {
      assessmentCost = document.getElementById("assessmentCost") ?? '';
      let im = new Inputmask("currency", {
        groupSeparator: ',',
        prefix: '$',
        allowMinus: false
      });
      im.mask(assessmentCost);
    }
  }
  
  ngOnInit() {
    this.status.emit(undefined);
    this.setMask();
    this.form.patchValue({
      assessment_cost: this.report().assessment_cost,
    })
    if (this.report().report_num == 1) this.loadPre(); //only load pre-assessment data on initial
    this.report().forests.forEach((forest: ReportForest & { data: any[] }) => {
      forest.data = []
      forest.treatments!.forEach((treatment: ForestTreament) => {
        treatment.treatment_specifications!.forEach((spec: TreamentSpecification) => {
          forest.data.push({
            type: treatment.treatment_type?.treatment_type,
            treatment: treatment.treatment_option?.treatment_option,
            spec_number: spec.specification_number,
            spec_name: spec.specification_name,
            off_nfs: spec.treatment_off_nfs_land,
            outside_fire: spec.treatment_outside_fire,
            unit_type: treatment.treatment_option?.unit_of_measure,
            unit_qty: spec.custom_unit_qty ?? spec.gis_unit_qty,
            unit_cost: spec.unit_cost,
            from_GIS: spec.from_GIS
          })
        })
      })

      forest.data.sort((a: any, b: any) => a.spec_number < b.spec_number ? -1 : 1);
      forest.data.sort((a: any, b: any) => a.treatment < b.treatment ? -1 : 1);
    })
    this.totalRequestedCalc();
    this.loaded.emit(true);

    this.form.valueChanges.subscribe((value: any) => {
      this.status.emit(this.form.controls.assessment_cost.valid ? 2 : 1);
    })
  }

  loadPre() {
    this.reportService.getReportList(this.report().assessment_id, "&relations=forests.treatments.treatment_specifications").subscribe((data: any) => {
      this.pre_assessment_report = data.reports.find((report: any) => report.report_num == 0);
    })
    this.report().users.forEach((user: any) => {
      let skill_found = user.skills.find((skill: any) => skill.skill_id == 4); //GIS
      if (skill_found) this.gis_specialist = user;
    })
  }

  ngOnChanges(): void {
    if (this.nav() != '') this.navigate();
  }

  unitTotal(item: any) {
    return item.unit_cost * item.unit_qty;
  }

  forestTotal(forest: ReportForest & { data: any[] }) {
    let total = 0;
    if (forest.data)
      for (let item of forest.data) {
        total += this.unitTotal(item);
      }
    return total;
  }

  totalRequestedCalc() {
    let total = 0;
    for (let forest of this.report().forests) {
      total += this.forestTotal(forest);
    }
    this.totalRequested = total;
  }

  navigate() {
    let allFieldsFilled = this.save();
    switch (this.nav()) {
      case 'forward': {
        if (allFieldsFilled) {
          this.router.navigate(['/2500-8-report'], { queryParams: { report_id: this.report().report_id, report_page_input: +this.page() + 1 } });
        } else {
          this.form.markAllAsTouched();
          this.errorList = [];
          for (let field in this.form.controls) {
            const control = this.form.get(field);
            if (control?.invalid) {
              this.errorList.push(field.replaceAll('_', ' '));
            }
          }
          window.scrollTo({ top: 0, behavior: 'smooth' });
          this.nav.set('');
        }
        break;
      }
      case 'back': {
        this.router.navigate(['/2500-8-report'], { queryParams: { report_id: this.report().report_id, report_page_input: +this.page() - 1 } });
        break;
      }
      case 'close': {
        this.router.navigate(['fire-overview'], { queryParams: { assessment_id: this.report().assessment_id } });
        break;
      }
      default: {
        if (Number(this.nav()))
          this.router.navigate(['/2500-8-report'], { queryParams: { report_id: this.report().report_id, report_page_input: this.nav() } });
        break;
      }
    }
  }

  save() {
    if (!this.form.dirty) {
      // Don't save if nothing has changed
      return true
    }

    // Convert blank number fields to undefined
    let numbers = ["assessment_cost"]
    for (let field of numbers) {
      if (this.form.get(field)?.value === "") {
        this.form.patchValue({ [field]: null })
      } else if (this.form.get(field)?.value != null) {
        if (this.form.get(field)?.value.toString().charAt(0) == "$") {
          this.form.patchValue({ [field]: +this.form.get(field)?.value.substring(1).replaceAll(',', '') })
        } else {
          this.form.patchValue({ [field]: +this.form.get(field)?.value })
        }
      }
    }

    let allFieldsFilled = true

    for (let field in this.form.controls) {
      if (this.form.get(field)?.value === null || this.form.get(field)?.value === "") {
        allFieldsFilled = false
      }
    }

    this.reportService.updateReport({
      report_id: this.report().report_id,

      assessment_cost: this.form.value.assessment_cost as string | undefined,

      [`page_${this.page()}_status_id`]: allFieldsFilled ? 2 : 1,
    }).subscribe({
      next: (response) => {
      },
      error: (response) => {
        this.toast.openErrorSnackBar(`There was an error saving the report`, "Please try again.");
      },
    })
    return allFieldsFilled
  }

  save_close() {
    this.save();
    this.router.navigate(['fire-overview'], { queryParams: { assessment_id: this.report().assessment_id } });
  }
}
